<template>
  <div>
    <!-- 结算态：左右对比卡片 -->
    <div
      v-if="settled"
      :class="isPC ? 'flex gap-[15px] h-[133px] justify-center' : 'flex gap-[8px]'"
    >
      <!-- 左侧：最终结果 -->
      <div
        class="rounded-[16px] "
        :class="isPC ? 'pt-[16px] pl-[20px] pr-[22px] w-[233px] flex-none bg-[#f6f7f9]' : 'flex-1 px-[22px] pt-[26px] pb-[16px] bg-white'"
      >
        <span
          class="block text-[#7a7a7a]"
          :class="isPC ? 'text-[22px] leading-[25px] mb-[30px]' : 'text-[24px] leading-[28px] mb-[20px]'"
        >
          {{ $t('finalResult') }}
        </span>
        <span class="block text-[40px] leading-[46px] font-bold text-[#121212]">
          {{ formattedCorrectValue }}
        </span>
      </div>
      <!-- 右侧：我的分析 -->
      <div
        class="rounded-[16px]"
        :class="isPC ? 'pt-[16px] pl-[20px] pr-[22px] w-[233px] flex-none bg-[#f6f7f9]' : 'flex-1 px-[22px] pt-[26px] pb-[16px] bg-white'"
      >
        <span
          class="block text-[#7a7a7a]"
          :class="isPC ? 'text-[22px] leading-[25px] mb-[30px]' : 'text-[24px] leading-[28px] mb-[20px]'"
        >
          {{ pick($t, 'myAnalysis', 'myPrediction') }}
        </span>
        <span
          class="block text-[40px] leading-[46px] font-bold"
          :class="settleStatus === 'WON' ? 'text-[#121212]' : 'text-[#C3C3C3]'"
        >
          {{ formattedAnswer || '--' }}
        </span>
      </div>
    </div>

    <!-- 进行中 -->
    <div
      v-else
      class="rounded-[16px] bg-white overflow-hidden flex items-center "
      :class="[
        isPC ? 'pl-[0] justify-center ' : 'pl-[23px] pr-[35px] h-[132px]',
        isPC && myAnswer ? 'h-[85px] border border-solid border-[#DDD] w-[480px] mx-[auto]' : ''
      ]"
    >
      <!-- 已提交预测：展示用户答案 + 编辑图标 -->
      <div v-if="myAnswer"
        class="flex items-center "
        :clas="isPC ? '' : ''"
        @click="editable && emit('click-cta')"
      >
        <span
          class="font-bold text-[#FF6900]"
          :class="isPC ? 'text-[40px] leading-[46px]' : 'text-[44px] leading-[50px]'"
        >
          {{ formattedAnswer }}
        </span>
        <img
          v-if="editable"
          class="shrink-0 ml-[12px] w-[48px] h-[48px] cursor-pointer"
          src="../images/icon-edit.png"
        />
      </div>

      <!-- 未提交：昨日收盘价 + CTA 按钮 -->
      <div v-else class="flex items-center" :class="isPC ? 'w-[480px]' : 'justify-between w-full'">
        <div class="flex-1 min-w-0">
          <span
            class="block text-[#7a7a7a]"
            :class="isPC ? 'text-[22px] leading-[26px]' : 'text-[24px] leading-[28px]'"
          >
            {{ $t('yesterdayClose') }}
          </span>
          <span
            class="block font-bold text-[#00A870] mt-[8px]"
            :class="isPC ? 'text-[40px] leading-[46px]' : 'text-[48px] leading-[48px]'"
          >
            {{ formattedPrice }}
          </span>
        </div>

        <button
          type="button"
          class="shrink-0 rounded-[40px] bg-[#FF6900] text-white font-medium border-none outline-none"
          :class="isPC ? 'w-[230px] h-[60px] text-[24px]' : 'w-[200px] h-[64px] text-[28px]'"
          @click="emit('click-cta')"
        >
          {{ pick($t, 'analyzeCta', 'predictCta') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import { use as fegoUse } from '@fegobull/webapi';
import { useFegoPageInfo } from '@ark/web-shared/use';
import { useWording } from '../hooks/useWording';
import locales from '../locales';
const __sfc_main = {};
__sfc_main.props = {
  yesterdayPrice: {
    key: "yesterdayPrice",
    required: true,
    type: [String, Number]
  },
  myAnswer: {
    key: "myAnswer",
    required: false,
    type: [String, null],
    default: null
  },
  settled: {
    key: "settled",
    required: false,
    type: Boolean,
    default: false
  },
  correctValue: {
    key: "correctValue",
    required: false,
    type: [String, null],
    default: null
  },
  settleStatus: {
    key: "settleStatus",
    required: false,
    type: [String, null],
    default: null
  },
  editable: {
    key: "editable",
    required: false,
    type: Boolean,
    default: true
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emit = __ctx.emit;
  const {
    useI18n
  } = fegoUse;
  const $t = useI18n(locales);
  const {
    isPC
  } = useFegoPageInfo();
  const {
    pick
  } = useWording();
  const formattedPrice = computed(() => {
    const val = props.yesterdayPrice;
    if (val === '' || val == null) return '--';
    return '$' + val;
  });
  const formattedAnswer = computed(() => {
    const val = props.myAnswer;
    if (!val) return '';
    return '$' + val;
  });
  const formattedCorrectValue = computed(() => {
    const val = props.correctValue;
    if (!val) return '--';
    return '$' + val;
  });
  return {
    emit,
    $t,
    isPC,
    pick,
    formattedPrice,
    formattedAnswer,
    formattedCorrectValue
  };
};
export default __sfc_main;
</script>
